import {
  BugOutlined,
  PlusSquareOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons';
import React from 'react';

const ticketTypeConfig = {
  bug: {
    icon: <BugOutlined style={{ color: '#E5493A' }} />,
  },
  // eslint-disable-next-line camelcase
  feature_request: {
    icon: <PlusSquareOutlined style={{ color: '#4B9FFF' }} />,
  },
  task: {
    icon: <CheckSquareOutlined style={{ color: '#8C4BFF' }} />,
  },
};

export default ticketTypeConfig;
